import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DataStateChangeEventArgs } from "@syncfusion/ej2-angular-grids";
import { Observable, ReplaySubject, Subject } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorService } from "src/app/error.service";
import { GeneralService } from "src/app/service/general.service";
import { TimeSheetVerficationReturnBO, TimesheetVListBO, UpdateClaimBO } from "./verifications.model";

@Injectable({
    providedIn: "root",
})
export class VerificationsService {
    timesheetListId: any = [];
    errorlist: any = [];
    TimesheetId: any;
    timesheetVList: any = []
    ErrorNotes: any
    timesheetVerify = new ReplaySubject()
    constructor(
        private http: HttpClient,
        public errorService: ErrorService,
        public general: GeneralService,
        public datePipe: DatePipe
    ) {
    }

    GetAllEmployeesDropdown(): Observable<any> {
        let url = "api/Employee/GetAllEmployeesDropdown?";
        return this.http.get<any>(url, { observe: "response" }).pipe(
            map((data) => data.body),
            catchError(this.errorService.handleError)
        );
    }

    GetAllClientDropDown(): Observable<any> {
        let url = "api/Client/GetAllClientDropDown?";
        return this.http.get<any>(url, { observe: "response" }).pipe(
            map((data) => data.body),
            catchError(this.errorService.handleError)
        );
    }

    //==============================get employee permission==========================================//
    getpermission(paramsData: URLSearchParams): Observable<any> {
        let url = "api/FunctionPermission/getfunctionpermissionemployee?";
        return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    Selectbill(saveList: TimeSheetVerficationReturnBO[], url): Observable<any> {
        return this.http.post<any>(url, saveList, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    UpdateClaim(saveList: UpdateClaimBO, url): Observable<any> {
        return this.http.post<any>(url, saveList, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
}



